/**
 * A route that exists in the product and not yet in the build.
 *
 * Shown rather than hidden, and it says which phase builds it. The same reason
 * an unreachable document stays on the rail with its reason: what is missing is
 * part of what the tool is, and a nav item that quietly is not there teaches
 * nobody anything.
 */
export function Stub({ title, phase, what }: { title: string; phase?: string; what: string }) {
  return (
    <div className="page">
      <header>
        <h1>{title}</h1>
        {phase ? <p className="muted small">Built in {phase}.</p> : null}
      </header>
      <div className="card">
        <div className="body">
          <p>{what}</p>
        </div>
      </div>
    </div>
  )
}
